import React, { useState, useRef, useEffect } from 'react';
import ChatBubble from '../Components/Chatbubble';
import MessageInput from '../Components/MessageInput';
import aiAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png';
import TypingDots from '../Components/TypingDots';

// ← only use the real API URL in production
const API_BASE =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_URL
    : '';

const LearnAndGrow = () => {
  const [chatLog, setChatLog] = useState([
    {
      sender: 'ai',
      avatar: aiAvatar,
      name: 'Kumar',
      message: `Let’s find you some 🔥 courses to level up your career game.\nWhat career are you interested in right now?`,
    },
  ]);
  const [isThinking, setIsThinking] = useState(false);
  const [courses, setCourses] = useState([]);

  // auto-scroll
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [chatLog, courses, isThinking]);

  const handleUserInput = async (text) => {
    if (!text.trim()) return;

    // add user message
    setChatLog((prev) => [
      ...prev,
      { sender: 'user', avatar: userAvatar, name: 'You', message: text },
    ]);
    setIsThinking(true);

    // build URL
    const url = `${API_BASE}/api/learn-courses?career=${encodeURIComponent(text)}`;
    console.log('LearnAndGrow fetching ➔', url);

    try {
      const res = await fetch(url);
      console.log('LearnAndGrow got status ➔', res.status);
      const data = await res.json();

      if (Array.isArray(data.courses)) {
        setCourses(data.courses);
        setChatLog((prev) => [
          ...prev,
          {
            sender: 'ai',
            avatar: aiAvatar,
            name: 'Kumar',
            message: `Here are some great course picks for becoming a **${text}**! 🎓 Let me know if you want more 🔍`,
          },
        ]);
      } else {
        throw new Error('No course list found');
      }
    } catch (error) {
      console.error(error);
      setChatLog((prev) => [
        ...prev,
        {
          sender: 'ai',
          avatar: aiAvatar,
          name: 'Kumar',
          message: `Oops 😢 I couldn’t fetch the courses. Please try again.`,
        },
      ]);
    } finally {
      setIsThinking(false);
    }
  };

  return (
    <div
      ref={containerRef}
      className="bg-white/90 backdrop-blur-lg rounded-[24px] shadow-md p-6 flex flex-col h-[86vh] w-full max-w-[950px] mx-auto overflow-hidden"
    >
      <div className="flex flex-col gap-6 overflow-y-auto flex-grow pr-2 custom-scroll">
        {chatLog.map((msg, idx) => (
          <ChatBubble
            key={idx}
            sender={msg.sender}
            avatar={msg.avatar}
            name={msg.name}
            message={msg.message}
          />
        ))}

        {isThinking && (
          <ChatBubble
            sender="ai"
            avatar={aiAvatar}
            name="Kumar"
            message={<TypingDots />}
          />
        )}

        {courses.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {courses.map((course, idx) => (
              <div
                key={idx}
                className="bg-white border border-gray-300 rounded-xl p-4 shadow-sm flex flex-col justify-between min-h-[180px]"
              >
                <div className="text-sm font-bold text-[#281D1B]">
                  {course.title}
                </div>
                <div className="text-xs mt-2 text-[#444]">
                  📚 Platform: {course.platform}
                </div>
                <div className="text-xs text-[#444]">⭐ Rating: {course.rating}</div>
                <div className="text-xs text-[#444]">{course.badge}</div>

                {course.link && (
                  <a
                    href={course.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#FF5733] text-white text-xs font-bold font-syne py-2 rounded-lg mt-3 hover:bg-[#e24e2f] transition text-center"
                  >
                    Start to Learn
                  </a>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-4">
        <MessageInput onSend={handleUserInput} />
      </div>
    </div>
  );
};

export default LearnAndGrow;
